import { Outlet } from 'react-router-dom';
import greenpillBg from '../assets/greenpill/greenpillBg.png';

function Greenpill() {
    return (
        <div
            style={{
                // backgroundImage: `url(${greenpillBg})`,
                backgroundColor: 'var(--bg-greenpill)',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
            }}
            className=" extraSize "
        >
            <Outlet />
        </div>
    );
}

export default Greenpill;
